import { render, staticRenderFns } from "./actressAction.vue?vue&type=template&id=ecc93b1c&scoped=true&"
import script from "./actressAction.vue?vue&type=script&lang=js&"
export * from "./actressAction.vue?vue&type=script&lang=js&"
import style0 from "./actressAction.vue?vue&type=style&index=0&id=ecc93b1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc93b1c",
  null
  
)

export default component.exports